export default "__VITE_ASSET__BVUQZnWg__"